import React from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, IconButton, Typography } from "@mui/material";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import Interval from "../store/Interval";
import Rule from "../store/Rule";

const useStyles = makeStyles()(() => ({
  icon: {
    color: "#7D8797",
    height: 20,
    width: 20,
  },
  error: {
    fontSize: "12px",
    textAlign: "center",
    color: "#963832",
  },
}));

type Props = {
  interval: Interval;
  rule: Rule;
};

const IntervalItem: React.FC<Props> = observer(({ interval, rule }) => {
  const { classes } = useStyles();
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box
        display="flex"
        alignItems="center"
        flexDirection={{ xs: "column", md: "row" }}
        gap={{ xs: 1, md: 0 }}
      >
        <MuiTimePicker
          slotProps={{
            textField: {
              error: !!interval.errorMessage,
              fullWidth: true,
            },
          }}
          sx={{ marginBottom: { xs: 0, md: 2 } }}
          onAccept={(date: Date | null) => {
            interval.setIntervalStartTime(date);
          }}
          value={interval.startTime}
        />
        <Typography
          variant="body1"
          sx={{
            marginLeft: 2,
            marginRight: 2,
            display: { xs: "none", md: "block" },
          }}
        >
          -
        </Typography>
        <MuiTimePicker
          slotProps={{
            textField: {
              error: !!interval.errorMessage,
              fullWidth: true,
            },
          }}
          sx={{ marginBottom: { xs: 0, md: 2 } }}
          value={interval.endTime}
          onAccept={(date: Date | null) => {
            interval.setIntervalEndTime(date);
          }}
        />
        <IconButton
          sx={{ marginLeft: { xs: 0, md: 2 } }}
          onClick={() => rule.removeInterval(interval)}
        >
          <DeleteOutlineIcon className={classes.icon} />
        </IconButton>
      </Box>
      <Typography variant="caption" color="red">
        {interval.errorMessage}
      </Typography>
    </Box>
  );
});

export default IntervalItem;
